import { DeviceInfo } from "../../../../Device/Info/DeviceInfo";
import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { helper } from "../AlignPanelWidthCounter";
import { ControlParams } from "./ControlInterfaces";
import { CultureDependentEditableControl } from "./CultureDependentEditableControl";

/**
 * Abstraktni trida - predek vsech date/time controlu.
 * Stara se hlavne o nastaveni jednotne HTML struktury controlu, ktera je vsude podobna.
 * Implementovany jen nektere metody.
 */
export class DateEditsParent extends CultureDependentEditableControl {
    //#region Fields
    /** pretypovani InnerElementu z predka. InnerElement je element zobrazeny uzivateli, fakeInput je pomocny input v pozadi pro zajisteni spravne funkcionality. */
    public override innerElement: HTMLInputElement;

    /**
     * fakeInput - bud je to skryty nativni date input, pomoci ktereho se zobrazuje nativni kalendar,
     * nebo je to skryty input typu text, na ktery se navaze jQuery Datepicker. Picker totiz omezuje
     * zadavane znaky jen na dany format data, ale pozadavek je, aby mohlo byt oddelovacem cokoliv.
     */
    protected _fakeInput: HTMLInputElement;
    /** obrazek kalendare/hodin */
    protected _calPicker: HTMLElement;

    //#endregion Fields

    //#region Constructors
    constructor(params: ControlParams) {
        super(params);

        this.initStaticFields();

        this.element.classList.add("DatesEdits"); // obecna trida pro vsechny Date/Time/DateTime edity

        this._fakeInput = (this.constructor as any).createFakeInput(); // volani konkretni staticke metody
        this._calPicker = this._createValuePicker();
        if (this._calPicker)
            this._calPicker.textContent = this.setPickerText();

        this.innerElement = DateEditsParent.createInnerElement(this.element);

        this._setPlaceholder();
        this.setOtherProperties();
        this.composeElements();
        this._setCaptionReference(this.innerElement);
    }
    //#endregion Constructors

    private _setPlaceholder(): void {
        if (this.innerElement && this._placeholderLocKey) {
            const setPlaceholder = () => Localization.getTextPromise(this._placeholderLocKey)
                .then(placeholder => this.innerElement.placeholder = placeholder);
            setPlaceholder();
            this._events.add(Localization.languageChanged, () => setPlaceholder());
        }
    }

    //#region Methods
    //#region MUST Implement
    // rozsirujici tridy musi implementovat metody v tomto regionu

    /**Inicializuje staticke prvky na tride - pomocne promenne, lokalizace, ...*/
    public initStaticFields(): void {
        alert("must implement parent method InitStaticFields()");
    }

    /** metoda na vytvoreni fake input */
    public static createFakeInput(): HTMLInputElement {
        alert("must implement parent method createFakeInput()");
        return null;
    }

    /** nasetovani textu pro ikonu kalendare/hodin */ /*
        public getPickerText(): string { alert('must implement parent method getPickerText()'); return null; }*/

    /** nastavi dalsi vlastnosti objektu (zejmena potrebne jeste pred volanim composeElements) */
    public setOtherProperties(): void {
        alert("must implement parent method setOtherProperties()");
    }

    /** metoda na poskladani vsech elementu ve spravnem poradi */
    public composeElements(): void {
        alert("must implement parent method composeElements()");
        return null;
    }
    //#endregion MUST Implement

    /** Jednotna metoda pro nastavovani obrazku pro date/time picker */
    public setPickerText(): string {
        if (DeviceInfo.deviceProperties.iOS)
            return "\uF152";
        if (DeviceInfo.deviceProperties.blackBerry)
            return "\uE60C";
        if (DeviceInfo.deviceProperties.wp)
            return "\u00A0"; // &nbsp;

        return ""; //pro desktop se ikona nastavuje v CSS
    }

    /** vraci standardni fakeInput jako input element */
    public static createNormalFakeInput(): HTMLInputElement {
        return createElement({ type: "input", classes: "fakeinput", attrs: { "tabindex": "-1" } }) as HTMLInputElement;
    }

    /** metoda na vytvoreni standardniho obrazku */
    public static createNormalCalPicker(): HTMLElement {
        const cp = document.createElement("span");
        cp.className = "calImg";
        cp.tabIndex = 0;
        return cp;
    }

    /** metoda na vytvoreni inner element */
    public static createInnerElement(element: HTMLElement): HTMLInputElement {
        const inner = createElement({ type: "input" }) as HTMLInputElement;

        if (helper.getAttr(element, "lockey"))
            Localization.addLocDescData(inner, helper.getAttr(element, "lockey"), "title");
        return inner;
    }

    /** metoda pro seskladani vsech prvku pro nativni inputy: vespod vpravo obrazek kalendare, nad tim fake input (pruhledny), nad tim vlevo input na psani */
    public composeForNativeWithFake(): void {
        this.element.classList.add("native");
        this.element.appendChild(this._fakeInput);
        this.element.appendChild(document.createElement("br")); // TODO - kvuli errDiv? - zjistit
        this.element.appendChild(this.innerElement);
        if (this._calPicker)
            this.element.appendChild(this._calPicker);
    }

    /** metoda pro seskladani vsech prvku pro ne-nativni inputy: nejdriv pripadny fake input, pak vpravo obrazek kalendare, pak input na psani */
    public composeForNotNative(): void {
        if (this._fakeInput)
            this.element.appendChild(this._fakeInput);
        this.element.appendChild(this.innerElement);
        this.element.appendChild(this._calPicker);
    }

    protected override _setEnabledInput(value: boolean): void {
        if (this.innerElement) {
            this.innerElement.readOnly = !value;
            if (this._fakeInput) {
                if (!value) {
                    this._fakeInput.setAttribute("disabled", "disabled");
                } else {
                    this._fakeInput.removeAttribute("disabled");
                }
            }
        }
    }
    //#endregion Methods
}
